import { Button, Card, Col, Form, Input, Row, Select, Typography } from "antd";
import { Navigate } from "react-router-dom";
import styles from "./AddNewAccount.module.css";

import { useAddAccountMutation, useGetMainAccountQuery } from "../../redux/rtk/features/account/accountApi";
import Loader from "../loader/loader";

const AddAccount = ({ drawer }) => {
	const { data: accounts, isLoading } = useGetMainAccountQuery();
	const [AddAccount, { isLoading: addLoading, isSuccess }] = useAddAccountMutation();

	const { Title } = Typography;

	const [form] = Form.useForm();

	const onFinish = async (values) => {
		await AddAccount(values);
		if (isSuccess) {
			form.resetFields();
		}
	};

	const onFinishFailed = (errorInfo) => {
		console.log("Failed:", errorInfo);
	};

	const isLogged = Boolean(localStorage.getItem("isLogged"));

	if (!isLogged) {
		return <Navigate to={"/admin/auth/login"} replace={true} />;
	}

	if (isLoading) {
		return <Loader />;
	}
	return (
		<div>
			<Row className='mr-top ' justify={drawer ? "center" : "space-between"}>
				<Col
					xs={24}
					sm={24}
					md={24}
					lg={drawer ? 22 : 11}
					xl={drawer ? 22 : 11}
					className='border rounded column-design'>
					<Card bordered={false}>
						<Title level={4} className='m-2 text-center'>
							Add Account
						</Title>
						<Form
							form={form}
							name='basic'
							labelCol={{
								span: 7,
							}}
							labelWrap
							wrapperCol={{
								span: 16,
							}}
							initialValues={{
								remember: true,
							}}
							onFinish={onFinish}
							onFinishFailed={onFinishFailed}
							autoComplete='off'>
							<Form.Item
								style={{ marginBottom: "10px" }}
								name='name'
								label='Name'
								rules={[
									{
										required: true,
										message: "Please input debit account!",
									},
								]}>
								<Input placeholder='Name' />
							</Form.Item>

							<Form.Item
								style={{ marginBottom: "10px" }}
								name='account_id'
								label='Account Type'
								rules={[
									{
										required: true,
										message: "Please input debit account!",
									},
								]}>
								<Select
									loading={!accounts}
									showSearch
									placeholder='Select Account Type'
									optionFilterProp='children'
									filterOption={(input, option) =>
										option.children.includes(input)
									}
									filterSort={(optionA, optionB) =>
										optionA.children
											.toLowerCase()
											.localeCompare(optionB.children.toLowerCase())
									}>
									{accounts &&
										accounts.map((acc) => (
											<Select.Option key={acc.id} value={acc.id}>
												{acc.name}
											</Select.Option>
										))}
								</Select>
							</Form.Item>

							<Form.Item
								style={{ marginBottom: "10px" }}
								className={styles.addNewAccountBtnContainer}>
								<Button
									type='primary'
									htmlType='submit'
									shape='round'
									size='large'
									loading={addLoading}
								>
									Add New Account
								</Button>
							</Form.Item>
						</Form>
					</Card>
				</Col>
			</Row>
		</div>
	);
};

export default AddAccount;
